<script setup lang="ts">
import SpData from '@/assets/SpData.svg';
import { ButtonType, CustomButton } from '../common';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { BACKEND_URL } from '@/services/apiClient';
import { DEEPLINK_ACTIONS, REDIRECTION_ACTIONS, routeConstants } from '@/utils';
import { useLoginStore } from '@/stores/login';
import { useAuthStore } from '@/stores/auth';

const loginStore = useLoginStore();
const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();

onMounted(() => {
  if (route.query.link) {
    loginStore.getDeepLinkData(route.query.link as string);
  } else if (route.query.investigationIdentifier || route.query.groupIdentifier) {
    loginStore.resolveBranchLink();
  } else if (route.query.auto_login == 'true') {
    loginWithStudypages();
  } else if (route.query.app_login == 'true') {
    window.location.href = `teamscope://(login)`;
  }
});

const trySpDataClick = () => {
  window.location.replace('https://www.teamscopeapp.com/lp/onboarding');
};

const openSignUpPageForPublicLink = () => {
  router.push({
    name: routeConstants.SIGNUP.name
  });
};

const loginWithStudypages = () => {
  let state = 'random_state';
  if (loginStore.deepLinkData) {
    state = JSON.stringify({
      action: REDIRECTION_ACTIONS.ACTION_JOIN_STUDY,
      token: loginStore.deepLinkData.token,
      studyIdentifier: loginStore.deepLinkData.studyId,
      groupIdentifier: loginStore.deepLinkData.groupId
    });
  } else if (typeof route.query.next === 'string') {
    state = JSON.stringify({
      next: route.query.next
    });
  }
  localStorage.setItem('loginAttempt', '0');
  loginStore.studypagesOauth(state);
};
</script>

<template>
  <div class="login-root">
    <div class="login-paper">
      <div class="paper-root">
        <div class="logo-root">
            <img alt="Studypages Data" :src="SpData" class="logo"/>
        </div>

        <div class="link-data" v-if="loginStore.deepLinkData">
            <img alt="Studypages Data" :src="`${BACKEND_URL}${loginStore.deepLinkData.avatar}`" class="avatar"/>

            <h1>Welcome to <span class="header">{{ loginStore.deepLinkData.studyTitle }}</span> on Studypages data</h1>

            <h3>Group: {{ loginStore.deepLinkData.groupName }}</h3>
        </div>
        
        <CustomButton :text="loginStore.deepLinkData ? authStore.userLoggedIn ? 'Go to study' : 'Login and Join' : 'Login with Studypages'"
          :type="ButtonType.POSITIVE"
          :fontWeight="600"
          @onClick="loginWithStudypages"
          class="button"/>

        <hr />

        <CustomButton text="Create new account"
          :type="ButtonType.OUTLINED"
          :fontWeight="600"
          v-if="loginStore.deepLinkData?.action === DEEPLINK_ACTIONS.PUBLIC_LINK_JOIN_STUDY"
          @onClick="openSignUpPageForPublicLink"
          class="button"/>

        <CustomButton text="Try Studypages Data for Free"
          :type="ButtonType.OUTLINED"
          :fontWeight="600"
          v-if="loginStore.deepLinkData?.action !== DEEPLINK_ACTIONS.PUBLIC_LINK_JOIN_STUDY"
          @onClick="trySpDataClick"
          class="button"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-root {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-paper {
  width: 688px;
  padding: 40px 0 100px 0;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.15);
}
.paper-root {
    display: flex;
    flex-direction: column;
    width: 400px;
    margin: 0 auto;
}
.logo-root {
    display: flex;
    justify-content: center;
    .logo {
        max-width: 220px;
        padding-bottom: 32px;
    }
}
.button {
    font-size: 14px;
    line-height: 20px;
}
hr {
    margin: 40px auto;
    width: 100px;
    border-color: rgba(0, 0, 0, 0.12);
}
.link-data {
    text-align: center;
    margin-bottom: 40px;

    h1 {
        font-size: 20px;
    }
}
.avatar {
    width: 80px;
    margin: 20px 0 12px 0;
    border: 1px solid #d9dee4;
    border-radius: 4px;
}
.header {
  font-weight: 700;
}
</style>
